import axios, { CustomParamsSerializer, ParamsSerializerOptions } from "axios";
import qs from "qs";

import { setupInterceptors } from "./interceptors";
import { SessionClient } from "../../domain/clients";

const paramsSerializer = (
  params: ParamsSerializerOptions | CustomParamsSerializer
) => qs.stringify(params, { arrayFormat: "brackets", skipNulls: true });

export const createAxiosClient = (
  baseURL: string,
  sessionClient: SessionClient
) => {
  const instance = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    paramsSerializer,
  });

  return setupInterceptors(instance, sessionClient);
};
